import { useTranslation } from "react-i18next";

export function CertificateGuideContent(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="space-y-6 text-sm">
      <section>
        <h3 className="font-semibold text-foreground mb-2">
          {t("onboarding.certificateGuide.whatIsTitle")}
        </h3>
        <p className="text-foreground font-medium">
          {t("onboarding.certificateGuide.whatIs")}
        </p>
      </section>
      <section>
        <h3 className="font-semibold text-foreground mt-4 mb-2">
          {t("onboarding.certificateGuide.whatForTitle")}
        </h3>
        <p className="text-muted-foreground">
          {t("onboarding.certificateGuide.whatFor")}
        </p>
      </section>
      <section>
        <h3 className="font-semibold text-foreground mt-4 mb-2">
          {t("onboarding.certificateGuide.validityTitle")}
        </h3>
        <p className="text-muted-foreground">
          {t("onboarding.certificateGuide.validity")}
        </p>
      </section>
      <section>
        <h3 className="font-semibold text-foreground mt-4 mb-2">
          {t("onboarding.certificateGuide.typesTitle")}
        </h3>
        <p className="text-muted-foreground">
          {t("onboarding.certificateGuide.types")}
        </p>
      </section>
      <section>
        <h3 className="font-semibold text-foreground mt-4 mb-2">
          {t("onboarding.certificateGuide.whereToGet")}
        </h3>
        <p className="text-muted-foreground mb-3">
          {t("onboarding.certificateGuide.whereToGetIntro")}
        </p>
        <ul className="list-disc list-inside space-y-2 pl-2 text-muted-foreground">
          <li>
            {t("onboarding.certificateGuide.providerCorreo")}{" "}
            {t("onboarding.certificateGuide.providerCorreoUrl") && (
              <a
                href={t("onboarding.certificateGuide.providerCorreoUrl")}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline hover:no-underline"
              >
                {t("onboarding.certificateGuide.providerLinkText")}
              </a>
            )}
          </li>
          <li>
            {t("onboarding.certificateGuide.providerAbitab")}{" "}
            {t("onboarding.certificateGuide.providerAbitabUrl") && (
              <a
                href={t("onboarding.certificateGuide.providerAbitabUrl")}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline hover:no-underline"
              >
                {t("onboarding.certificateGuide.providerLinkText")}
              </a>
            )}
          </li>
          <li>
            {t("onboarding.certificateGuide.providerAntel")}{" "}
            {t("onboarding.certificateGuide.providerAntelUrl") && (
              <a
                href={t("onboarding.certificateGuide.providerAntelUrl")}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline hover:no-underline"
              >
                {t("onboarding.certificateGuide.providerLinkText")}
              </a>
            )}
          </li>
        </ul>
      </section>
      <section>
        <p className="text-muted-foreground">
          {t("onboarding.certificateGuide.closing")}
        </p>
      </section>
    </div>
  );
}
